import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConfirmLoanAllocationModal } from '../../../common/modals';
import { connectModal } from '../../../features/modal/hoc';
import { selectData } from '../../../features/modal/ducks';
import { confirmLoanActions, resendSmsCodeLoanRequest } from '../ducks';
import { apiCallIds } from '../api';

const mapStateToProps = state => ({
  loanId: selectData(state, apiCallIds.CONFIRM_LOAN),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      confirmLoan: confirmLoanActions.request,
      resendSmsCodeLoan: resendSmsCodeLoanRequest,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.CONFIRM_LOAN)
export default class ConfirmLoan extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    loanId: PropTypes.string,
  };

  handleResendSmsCode = callbacks => {
    const { actions, loanId } = this.props;
    actions.resendSmsCodeLoan({ loanId, ...(callbacks || {}) });
  };

  handleSubmit = token => {
    const { actions, loanId } = this.props;
    actions.confirmLoan({ loanId, token });
  };

  render() {
    const { isVisible, isLoading, modalActions, loanId } = this.props;

    if (!isVisible) {
      return null;
    }

    return (
      <ConfirmLoanAllocationModal
        hideModal={modalActions.hide}
        isLoading={isLoading}
        onSubmit={this.handleSubmit}
        onResendSmsCode={this.handleResendSmsCode}
        resendCooldownKey={`loan:${loanId}:loan`}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/loans/components/ConfirmLoan.js